import React, { useState, useEffect } from 'react';
import client from '../api/client';

function Settings({ token }) {
    const [key, setKey] = useState('');
    const [message, setMessage] = useState('');
    const [hasKey, setHasKey] = useState(false);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const checkKeyStatus = async () => {
            try {
                const response = await client.get('/settings/openrouter-key-status');
                setHasKey(response.data.has_key);
            } catch (err) {
                console.error('Failed to check key status', err);
            } finally {
                setLoading(false);
            }
        };

        checkKeyStatus();
    }, []);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setMessage('');

        try {
            await client.post('/settings/openrouter-key', { key });
            setMessage('API Key saved successfully!');
            setHasKey(true);
            setKey('');
        } catch (err) {
            setMessage(err.response?.data?.message || 'Failed to save key');
        }
    };

    if (loading) return <div>Loading...</div>;

    return (
        <div className="card" style={{ maxWidth: '500px', margin: '0 auto' }}>
            <h2>Settings</h2>

            {hasKey ? (
                <div style={{ padding: '15px', backgroundColor: '#1e3a1e', borderRadius: '8px', marginBottom: '20px' }}>
                    <p style={{ color: '#4ade80', margin: 0 }}>✓ OpenRouter API key is already connected</p>
                </div>
            ) : (
                <p>Enter your OpenRouter API Key to enable chat functionality.</p>
            )}

            {message && <p style={{ color: message.includes('success') ? 'green' : 'red' }}>{message}</p>}

            <form onSubmit={handleSubmit}>
                <input
                    type="password"
                    placeholder={hasKey ? "Enter new key to update..." : "sk-or-..."}
                    value={key}
                    onChange={(e) => setKey(e.target.value)}
                    required
                />
                <button type="submit">{hasKey ? 'Update Key' : 'Save Key'}</button>
            </form>
        </div>
    );
}

export default Settings;
